// src/components/forms/IconButton/IconButton.tsx
import {
  IconButton as ChakraIconButton
} from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var sizeMap = {
  sm: {
    fontSize: "0.75rem",
    // 12px
    maxDimensions: "2rem"
    // 32px
  },
  lg: {
    fontSize: "1.25rem",
    // 20px
    maxDimensions: "2.5rem"
    // 40px
  }
};
var IconButton = (props) => /* @__PURE__ */ jsx(
  ChakraIconButton,
  {
    lineHeight: "1",
    padding: "0.625rem",
    textOverflow: "clip",
    maxW: props.size && sizeMap[props.size]?.maxDimensions || "2rem",
    maxH: props.size && sizeMap[props.size]?.maxDimensions || "2rem",
    fontSize: props.size && sizeMap[props.size]?.fontSize || "0.75rem",
    _hover: { bg: props.isDisabled && "neutral.200" },
    _disabled: {
      bg: props.bg ? "neutral.200" : "transparent",
      color: "neutral.400",
      _hover: {
        bg: props.bg ? "neutral.200" : "transparent",
        color: "neutral.400"
      }
    },
    bg: !props.variant ? "transparent" : props.bg,
    ...props
  }
);
var IconButton_default = IconButton;

export {
  IconButton_default
};
